import { Component } from '@angular/core';
import { ResponsiveService } from '../../../services/responsive.service';
import { TranslatorService } from '../../../services/translator_service';
import { ApiQuery } from '../../../web-services/api/api.query';
import { ApiService } from '../../../web-services/api/api.service';
import moment from 'moment';
import { ApiStore } from '../../../web-services/api/api.store';
import _ from 'lodash';
import * as pako from 'pako';
import { TranslatePipe } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { DatepickerRange } from '../../../widgets/datepicker-range/datepicker-range';
import { CollectionKpi } from '../../collection-kpi/collection-kpi';
import { CollectionStatusPie } from '../../collection-status-pie/collection-status-pie';
import { CollectionReportPie } from '../../collection-report-pie/collection-report-pie';
import { CollectionsTable } from '../collections-table/collections-table';
import { SystemRecommendation } from '../system-recommendation/system-recommendation';
import { CommonModule } from '@angular/common';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-collections',
  imports: [TranslatePipe, RTLDivDirectiveDirective, MatDividerModule, MatCardModule, DatepickerRange,
    CollectionKpi,CollectionStatusPie,CollectionReportPie,CollectionsTable,CommonModule,SystemRecommendation],  
  templateUrl: './collections.html',
  styleUrl: './collections.scss',
})
export class Collections {
  isMobile: Boolean;
	excel_disabled: boolean = true;
	showSpinner:boolean=false;
	newUrl:string = "";
	reportBody:object={};
	selectedDates: any = {
		from: '',
		to: ''
	};
	showKPIBtn : boolean = false;
	showReportPieBtn : boolean = false;
	showReportPieTabs : boolean = false;
	showDatePicker: Boolean = false;
	minDate = '';
	maxDate = '';
	datesDiff : any;
	lastMaxDate:any;
	lastMinDate:any;
	currentLang;
	translationsObj;
	collectionMode:boolean = true;

	constructor(private apiService:ApiService,private translator: TranslatorService,private apiQuery:ApiQuery,
		private apiStore:ApiStore,private responsiveService: ResponsiveService) {
			this.translator.currentLangEmitter$
			.subscribe(async value=>{						
				this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
				this.currentLang = value;			
			})
	}
	ngOnInit() {
		this.onResize();
		this.responsiveService.checkWidth();

		combineLatest([
			this.apiQuery.collectionsStatsInCollections$,
			this.apiQuery.collectionsKpis$,
			])
			.pipe()
			.subscribe(([collectionsStats,collectionsKpis])=>{	
				this.excel_disabled = collectionsStats.length == 0 || collectionsKpis.length == 0;
				if (this.excel_disabled) return;
			});
	}

	exportToCsv(){
		this.getExcelReport();
	}

	onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	  }

	public showHideDatePicker = () => {
		this.showDatePicker = !this.showDatePicker;
	}

	ngOnDestroy() {
		sessionStorage.removeItem('collectionsMinDate');
		sessionStorage.removeItem('collectionsMaxDate');
	}

	public onSelectDates = (selectDates: any) => {
		setTimeout(() => {
			this.showDatePicker = false;
			this.selectedDates.from = selectDates.fromDate;
			this.selectedDates.to = selectDates.toDate;		
			this.minDate = moment(this.selectedDates.from, 'DD.MM.YYYY').format('YYYY-MM-DD 00:00:01');
			this.maxDate = moment(this.selectedDates.to, 'DD.MM.YYYY').format('YYYY-MM-DD 23:59:59');
			sessionStorage.setItem("collectionsMinDate",this.minDate);
			sessionStorage.setItem("collectionsMaxDate",this.maxDate);
	
			sessionStorage.setItem("collectionsStartDate",this.minDate);
			sessionStorage.setItem("collectionsEndDate",this.maxDate);
	
			this.datesDiff = selectDates.fromDate + " - " + selectDates.toDate;		
			if(this.maxDate != this.lastMaxDate || this.minDate != this.lastMinDate){
				const chosenSites = JSON.parse(sessionStorage.getItem("chosenSites"));

				const dateRange = {
					start_date: this.minDate,
					end_date: this.maxDate
				};

				const statsRequest = {
					site_id_list : chosenSites?.filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
					...dateRange
				};

				const removedCollectionsStatsRequest = {
					site_id_list : chosenSites?.filter(site => site.hasOwnProperty('site_id')).map(site => site.site_id),
					...dateRange
				}

				this.apiStore.update({
					allCollectionsKpis: [],
					collectionsKpis: [],
					allCollectionsStats: [],
					collectionsStatsInCollections: []
				});

				if(chosenSites){
					this.apiService.getfilteredSiteCollectionsKpis(dateRange,chosenSites);
					this.apiService.getfilteredBinsCollectionsStats(statsRequest,5,chosenSites);
					this.apiService.RemovedSuspectedCollections(removedCollectionsStatsRequest);
					this.apiService.getUnApprovedAndDeletedSuspectedAsCollectionEvents(removedCollectionsStatsRequest);
					this.apiService.dailyWorkPlansTotalRecommendedCollections(statsRequest);
				}
				this.lastMinDate = this.minDate;
				this.lastMaxDate = this.maxDate;
			}
		}, 0);
	}

	getExcelReport(){//	
		if(!this.excel_disabled){
			this.showSpinner = true;
			this.excel_disabled = true;
			//@ts-ignore
			document.getElementById("excelExp").disabled = true;
			let sites = [];
			if(JSON.parse(sessionStorage.getItem("chosenSites")) != undefined && 
			JSON.parse(sessionStorage.getItem("chosenSites")).length > 0){
				_.each(JSON.parse(sessionStorage.getItem("chosenSites")), (item) => {   
					if(item.site_id != undefined){
						sites.push(item.site_id.toString().trim())
					}  
				}); 
			}	
			const reportLanguage = localStorage.getItem('language') == 'iw' ? 'he' : localStorage.getItem('language');
			this.reportBody = 
			{
				template: {
					shortid: "HvRpdblgP1"
				},
				data: {
					report_configuration: {
						report_lang: reportLanguage,
						sites_list: sites,
						report_time_zone: "2",
						report_start_date: this.minDate,
						report_end_date: this.maxDate
					},
					report_data: {
						binsCollectionsStats: {
							Bins_collections_data: this.apiStore.getValue()["collectionsStatsInCollections"]
						},
						GetSiteCollectionsKpis:{
							SiteCollectionKpiObj: this.apiStore.getValue()["collectionsKpis"]
						}
					}
				},
				options: {
					localization: {
						language: reportLanguage
					},
					preview: true
				} 
			};

			this.apiService.getReport(pako.gzip(JSON.stringify(this.reportBody)))
			.subscribe((res:any) => {			
				const contentType = res.headers.get('Content-Type') || '';
				const body: ArrayBuffer = res.body;
			
				// XLSX (large report)
				if (contentType.includes('spreadsheetml.sheet') || contentType.includes('application/octet-stream')) {
				  const cd = res.headers.get('Content-Disposition');
				  const filename = this.extractFilename(cd) || 'report.xlsx';
			
				  const blob = new Blob([body], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				  });
			
				  this.downloadFile(blob, filename);
				  this.finishUi();
				  return;
				}
			
				// HTML preview (small report)
				if (contentType.includes('text/html')) {
				  const html = new TextDecoder('utf-8').decode(body);
			
				  const doc = new DOMParser().parseFromString(html, 'text/html');
				  const iframeSrc = doc.querySelector('iframe')?.getAttribute('src');
				  if (!iframeSrc) throw new Error('No iframe src found in preview HTML');
			
				  this.finishUi();
				  window.open(iframeSrc);
				  return;
				}
			
				throw new Error(`Unexpected content type: ${contentType}`);
			});	
		}	
	}

	private extractFilename(contentDisposition: string | null): string | null {
		if (!contentDisposition) return null;
	  
		const star = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
		if (star?.[1]) {
		  try { return decodeURIComponent(star[1].trim()); } catch {}
		}
	  
		const normal = contentDisposition.match(/filename\s*=\s*"?([^"]+)"?/i);
		return normal?.[1]?.trim() ?? null;
	  }
	  
	  private downloadFile(blob: Blob, filename: string): void {
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = filename;
		a.style.display = 'none';
		document.body.appendChild(a);
		a.click();
	  
		setTimeout(() => {
		  window.URL.revokeObjectURL(url);
		  document.body.removeChild(a);
		}, 100);
	  }
	  
	  private finishUi() {
		this.showSpinner = false;
		this.excel_disabled = false;
		// @ts-ignore
		document.getElementById("excelExp").disabled = false;
	  }
	  

	collectionsModeHandler($event:any){		
		this.collectionMode = $event;
	}
}
